import { Component, computed } from '@angular/core'
import { ButtonComponent, DrawerDirective, IconComponent, selectWith } from '@ftr/foundation'
import { CartState } from '../../../store'
import { RequestCartSidePanelComponent } from '../side-panel'

@Component({
  selector: 'ftr-request-cart-side-panel-toggle',
  templateUrl: './request-cart-side-panel-toggle.component.html',
  styleUrl: './request-cart-side-panel-toggle.component.css',
  imports: [ButtonComponent, DrawerDirective, IconComponent, RequestCartSidePanelComponent],
})
export class RequestCartSidePanelToggleComponent {
  protected readonly numCartItems = selectWith(() => CartState.numCartItems)
  protected readonly hasCartItems = computed(() => this.numCartItems() > 0)
  protected readonly cartButtonAriaLabel = computed(() =>
    this.hasCartItems() ? `${this.numCartItems()} items cart` : 'cart',
  )
}
